import * as React from 'react'
import autobind from 'autobind-decorator'
import {connect} from 'redux-scaffolding-ts'
import {withTranslation, WithTranslation} from 'react-i18next'
import {Icon} from 'antd'
import SelectionInput from '../core/ui/form/selectionInput'
import {DropDownManagersStore} from 'src/stores/employees-store'
import {ItemReference, QueryResult} from 'src/core/stores/dataStore'


interface ManagerEditorProps extends WithTranslation {
    companyId: string,
    disabled?: boolean,
    value?: number,
    onChange?: (value: number) => void,
    placeholder?: string,
    nullable?: boolean,
    minWidth?: number,
    multiple?: boolean,
    employeeId: number,
    onDropdownVisibleChange?:(open:boolean) => void, 
}

interface ManagerEditorState {
    managerId: number | undefined,
}

@connect(["dropdownemployees", DropDownManagersStore])
class ManagerEditor extends React.Component<ManagerEditorProps, ManagerEditorState> {

    private get employeesStore() {
        return (this.props as any).dropdownemployees as DropDownManagersStore
    }

    constructor(props: ManagerEditorProps) {
        super(props)
        this.state = {
            managerId: props.value,
        }
        this.employeesStore.changeUrl(props.companyId, props.employeeId)
    }

    static getDerivedStateFromProps(nextProps: ManagerEditorProps, prevState: ManagerEditorState) {
        if (nextProps.value !== prevState.managerId) {
            return { managerId: nextProps.value }
        }
        else return null
    }

    @autobind
    private async getEmployees(searchQuery: string): Promise<QueryResult<ItemReference>> {
        this.employeesStore.changeUrl(this.props.companyId, this.props.employeeId)
        var result = await this.employeesStore.getAllAsync({
            searchQuery: searchQuery,
            skip: 0,
            parameters: {
                "includeIds": this.props.value,
            },
            take: 25,
            orderBy: [{ field: 'title', direction: "Ascending", useProfile: true }]
        }) || { count: 0, items: [] }

        return {
            count: result.count,
            items: result.items.map(o => ({
                id: `${o.id}`,
                title: `${o.title}`
            } as ItemReference))
        } as QueryResult<ItemReference>
    }

    public render() {
        return (<SelectionInput
            content={(o) =>
                <div>
                    <Icon type="idcard" />
                    <span>&nbsp;{o ? o.title : ""}</span>
                </div>}
            searchable
            forcereload={true}
            disabled={this.props.disabled}
            minWidth={this.props.minWidth}
            nullable={this.props.nullable}
            placeholder={this.props.placeholder}
            query={this.getEmployees}
            value={this.state.managerId as any}
            multiple={this.props.multiple}
            showFooter
            onChange={(item: any) => { if (this.props.onChange) { this.props.onChange(item && item.id ? item.id : item as any || undefined) } }} />)
    }
}

export default withTranslation()(ManagerEditor)